"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactsResponse = exports.ContactModel = exports.ContactFormService = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var json2typescript_1 = require("json2typescript");
var contactModalFields = [
    'id',
    'company_name',
    'type',
    'segments',
    'country_name',
    'country',
    'email',
];
var jsonConvert = new json2typescript_1.JsonConvert();
jsonConvert.valueCheckingMode = json2typescript_1.ValueCheckingMode.ALLOW_NULL;
var cache = {};
var ContactFormService = /** @class */ (function () {
    function ContactFormService(contactsApiUrl, locationApiKey) {
        this.connectionTimeout = 30000;
        this.contactsApiUrl = contactsApiUrl;
        this.locationApiKey = locationApiKey;
    }
    ContactFormService.prototype.getContactById = function (contactId) {
        if (cache[contactId]) {
            return Promise.resolve(cache[contactId]);
        }
        var params = this.getRequestParams(contactId);
        var headers = { 'x-api-key': this.locationApiKey };
        return app_1.api(this.contactsApiUrl, params, headers, null, this.connectionTimeout).then(function (_a) {
            var data = _a.data;
            var convertedContactDetailsData = jsonConvert.deserializeObject(data, ContactsResponse);
            var contacts = convertedContactDetailsData && convertedContactDetailsData.responseValue;
            cache[contactId] = contacts;
            return contacts;
        });
    };
    ContactFormService.prototype.getRequestParams = function (contactId) {
        var idFilter = "id eq '" + contactId + "'";
        return {
            $top: 1,
            $select: contactModalFields.join(', '),
            $filter: idFilter,
        };
    };
    return ContactFormService;
}());
exports.ContactFormService = ContactFormService;
var ContactModel = /** @class */ (function () {
    function ContactModel() {
        this.id = undefined;
        this.companyName = undefined;
        this.type = undefined;
        this.segments = undefined;
        this.country = undefined;
        this.countryCode = undefined;
        this.email = undefined;
    }
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('id', String),
        tslib_1.__metadata("design:type", String)
    ], ContactModel.prototype, "id", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('company_name', String),
        tslib_1.__metadata("design:type", String)
    ], ContactModel.prototype, "companyName", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('type', String),
        tslib_1.__metadata("design:type", String)
    ], ContactModel.prototype, "type", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('segments', [String]),
        tslib_1.__metadata("design:type", Array)
    ], ContactModel.prototype, "segments", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('country_name', String),
        tslib_1.__metadata("design:type", String)
    ], ContactModel.prototype, "country", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('country', String),
        tslib_1.__metadata("design:type", String)
    ], ContactModel.prototype, "countryCode", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('email', String),
        tslib_1.__metadata("design:type", String)
    ], ContactModel.prototype, "email", void 0);
    ContactModel = tslib_1.__decorate([
        json2typescript_1.JsonObject('ContactModel')
    ], ContactModel);
    return ContactModel;
}());
exports.ContactModel = ContactModel;
var ContactsResponse = /** @class */ (function () {
    function ContactsResponse() {
        this.responseValue = undefined;
    }
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('value', [ContactModel]),
        tslib_1.__metadata("design:type", Array)
    ], ContactsResponse.prototype, "responseValue", void 0);
    ContactsResponse = tslib_1.__decorate([
        json2typescript_1.JsonObject('ContactsResponse')
    ], ContactsResponse);
    return ContactsResponse;
}());
exports.ContactsResponse = ContactsResponse;
